export default "__VITE_ASSET__ls7BL4KY__"